module.exports = __webpack_public_path__ + "img/item11.eb921478.png";